import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  FORGET_PASSWORD_RESET,
} from "./actionTypes"

export const userForgetPassword = user => {
  return {
    type: FORGET_PASSWORD,
    payload: { user },
  }
}

export const userForgetPasswordReset = data => {
  return {
    type: FORGET_PASSWORD_RESET,
    payload: { data },
  }
}

export const userForgetPasswordSuccess = message => {
  return {
    type: FORGET_PASSWORD_SUCCESS,
    payload: message,
  }
}

export const userForgetPasswordError = message => {
  return {
    type: FORGET_PASSWORD_ERROR,
    payload: message,
  }
}
